import { Modal, ModalContent } from '@chakra-ui/react';
import { StandardSnack } from '@sketch-note/design-system/src/components/snackbar';
import { EditIcon, ErrorIcon } from '@sketchnote/icons';
import cn from 'classnames';
import React, { useState } from 'react';
import validator from 'validator';

import { useTasksStore } from '../../store/useTasksStore';
import { Task } from '../../types/tasks';

export const UrlFieldComponent = ({
  task,
  fieldId,
  data,
  disabled,
}: {
  task: Partial<Task>;
  fieldId: string;
  label: string;
  data: string;
  handleDelete: (flag: boolean) => void;
  disabled?: boolean;
}): JSX.Element => {
  const [fieldData, setFieldData] = useState(typeof data === 'string' ? data : '');
  const [isFocused, setIsFocused] = useState(false);
  const [errorModalIsOpen, setErrorModalIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(!data);

  const onUpdateCustomFieldData = useTasksStore((s) => s.onUpdateCustomFieldData);
  const onUpdateCustomTemplateFieldData = useTasksStore((s) => s.onUpdateCustomTemplateFieldData);

  const validate = (value): boolean => {
    return validator.isURL(value) ? true : false;
  };
  const handleErrorModal = () => {
    setErrorModalIsOpen(false);
  };

  const openInNewTab = (url: string): void => {
    if (!/^https?:\/\//i.test(url)) {
      url = 'http://' + url;
    }
    const newWindow = window.open(url, '_blank', 'noreferrer');
    if (newWindow) newWindow.opener = null;
  };

  return (
    <>
      {isEdit ? (
        <input
          disabled={disabled}
          type="text"
          placeholder="Add URL"
          className={cn(
            'text-sm text-gray-999 font-regular placeholder-gray-500 h-36 w-400 pl-15',
            {
              'bg-white rounded-sm border border-gray-200': isFocused,
            }
          )}
          onChange={(e) => {
            setFieldData(e.target.value);
          }}
          onFocus={() => {
            setIsFocused(true);
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              if (validate(fieldData)) {
                setIsEdit(!isEdit);
                setFieldData(fieldData);
                if (task.id) {
                  const payload = { taskId: task.id, fieldId: fieldId, data: fieldData };
                  if (task.board?.id === undefined) {
                    payload['taskTemplateRef'] = task.id;
                    onUpdateCustomTemplateFieldData(payload);
                  } else {
                    payload['taskTemplateRef'] = undefined;
                    onUpdateCustomFieldData(payload);
                  }
                }
              } else {
                setErrorModalIsOpen(true);
              }
            }
            setIsFocused(false);
          }}
          onBlur={() => {
            setIsFocused(false);
            if (validate(fieldData)) {
              setIsEdit(!isEdit);
              setFieldData(fieldData);
              if (task.id) {
                const payload = { taskId: task.id, fieldId: fieldId, data: fieldData };
                if (task.board?.id === undefined) {
                  payload['taskTemplateRef'] = task.id;
                  onUpdateCustomTemplateFieldData(payload);
                } else {
                  payload['taskTemplateRef'] = undefined;
                  onUpdateCustomFieldData(payload);
                }
              }
            } else {
              setErrorModalIsOpen(true);
            }
          }}
          value={fieldData}
        />
      ) : (
        <div
          className={cn('flex flex-row justify-between  h-36 w-400', {
            'bg-white rounded-sm border border-gray-200': isFocused,
          })}
          onBlur={() => {
            setIsFocused(false);
          }}
        >
          <input
            onClick={() => openInNewTab(fieldData)}
            type="text"
            placeholder="Add URL"
            readOnly={true}
            className={cn(
              'text-sm text-blue-600 font-regular placeholder-gray-500 h-34 w-400 pl-15 truncate pr-6',
              {
                'cursor-pointer': !isEdit,
              }
            )}
            value={fieldData}
          />
          {!disabled && (
            <button
              className="pr-10 text-sm"
              onClick={() => {
                if (disabled) return;
                setIsEdit(true);
                setIsFocused(true);
              }}
            >
              <EditIcon className="mr-2 text-gray-500" />
            </button>
          )}
        </div>
      )}
      <Modal isOpen={errorModalIsOpen} onClose={handleErrorModal}>
        <ModalContent style={{ width: '40rem', borderRadius: '10px', marginTop: '65rem' }}>
          <StandardSnack icon={<ErrorIcon />} text="Enter valid URL" />
        </ModalContent>
      </Modal>
    </>
  );
};
